export default {
  trainerReviewDialog(state) {
    return state.trainerReviewDialog;
  },
};
